import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "@/components/ui/pagination.tsx";
import { Pagy } from "@/lib/types/models.ts";

interface Props {
    pagy: Pagy;
    onPageChange: (page: number) => void;
}

export default function PaginationControls({ pagy, onPageChange }: Props) {
    const renderPageNumbers = () => {
        const { page, pages: totalPages } = pagy;
        const pages: (number | "ellipsis")[] = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else if (page <= 3) {
            pages.push(1, 2, 3, 4, "ellipsis", totalPages);
        } else if (page >= totalPages - 2) {
            pages.push(1, "ellipsis", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
        } else {
            pages.push(1, "ellipsis", page - 1, page, page + 1, "ellipsis", totalPages);
        }

        return pages.map((p, index) =>
            p === "ellipsis" ? (
                <PaginationItem key={`ellipsis-${index}`}>
                    <PaginationEllipsis />
                </PaginationItem>
            ) : (
                <PaginationItem key={p}>
                    <PaginationLink
                        href="#"
                        isActive={p === page}
                        onClick={(e) => {
                            e.preventDefault();
                            onPageChange(p);
                        }}
                    >
                        {p}
                    </PaginationLink>
                </PaginationItem>
            )
        );
    };

    return (
        <Pagination>
            <PaginationContent>
                <PaginationItem>
                    <PaginationPrevious
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (pagy.page > 1) onPageChange(pagy.page - 1);
                        }}
                    />
                </PaginationItem>
                {renderPageNumbers()}
                <PaginationItem>
                    <PaginationNext
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (pagy.page < pagy.pages) onPageChange(pagy.page + 1);
                        }}
                    />
                </PaginationItem>
            </PaginationContent>
        </Pagination>
    );
}